import type {
  FunctionMapping,
  OccupationMapping,
  SkillMapping,
} from 'bundles/enterprise-admin-skills/components/types';
import type { Skill } from 'bundles/enterprise-skillset-form/types';
import { unslugify } from 'bundles/enterprise-ui';
import type { LearnerSkillSetProficiency } from 'bundles/naptimejs/resources/skillSets.v1';

export const formatDepartmentName = (id?: string | null, mappings?: FunctionMapping[]) => {
  const mapping = mappings?.find((_) => _?.id === id)?.name;
  if (mapping) {
    return mapping;
  }
  return unslugify(id);
};

export const formatOccupationName = (id: string, mappings?: OccupationMapping[]) => {
  const mapping = mappings?.find((_) => _.id === id)?.name;
  if (mapping) {
    return mapping;
  }
  return unslugify(id);
};

export const areSkillIDsEqual = (a: string, b: string) => {
  return a.split('~')[0] === b.split('~')[0];
};

export const areSkillsEqual = (a: Skill, b: Skill) => {
  return a.skillId === b.skillId;
};

export const getSkillById = (skillId: string, mappings?: SkillMapping[]) => {
  return mappings?.find((_) => areSkillIDsEqual(_.skillId, skillId));
};

export const formatSkillName = (skillId: string, mappings?: SkillMapping[]) => {
  return getSkillById(skillId, mappings)?.skillName ?? unslugify(skillId.split('~')[0]) ?? '';
};

export const proficiencyFilter = (
  { skillId }: LearnerSkillSetProficiency,
  index: number,
  all: LearnerSkillSetProficiency[]
) => {
  const name = formatSkillName(skillId);
  const isDuplicate = all.map((_) => formatSkillName(_.skillId)).indexOf(name) !== index;
  return !isDuplicate;
};
